























import {computed, defineComponent, onMounted, ref, watch} from "@vue/composition-api"

const FULL_DASH_ARRAY = 283

const COLOR_CODES = {
  info: {
    color: "green"
  },
  warning: {
    color: "orange",
    threshold: 10
  },
  alert: {
    color: "red",
    threshold: 5
  }
}


export default defineComponent({
  name: 'Timer',
  props: {
    value: {
      type: Number,
      required: false,
      default: 20,
    },
    strokeWidth: {
      type: Number,
      required: false,
      default: 100
    },
    fontSizeRem: {
      type: Number,
      required: false,
      default: 4
    },
    start: {
      type: Boolean,
      required: true,
    }
  },
  setup(props, {emit}) {
    const clockSize = computed(() => props.strokeWidth * 0.9)
    const radius = computed(() => (clockSize.value * 0.9) / 2)

    const timeLimit = props.value
    const timePassed = ref(0)
    const timerInterval = ref<NodeJS.Timeout>(undefined)

    const timeLeft = computed(() => timeLimit - timePassed.value)
    const timeFraction = computed(() => {
      const rawTimeFraction = timeLeft.value / timeLimit
      return rawTimeFraction - (1 / timeLimit) * (1 - rawTimeFraction)
    })
    const circleDashArray = computed(() => `${(timeFraction.value * FULL_DASH_ARRAY).toFixed(0)} 283`)
    const formattedTimeLeft = computed(() => {
      const fixedTimeLeft = timeLeft.value
      const minutes = Math.floor(fixedTimeLeft / 60)
      const secondsLeft = fixedTimeLeft % 60
      const seconds = secondsLeft < 10 ? `0${secondsLeft}` : secondsLeft.toString()

      return `${minutes}:${seconds}`
    })
    const remainingPathColor = computed(() => {
      const { alert, warning, info } = COLOR_CODES

      if (timeLeft.value <= alert.threshold) {
        return alert.color
      } else if (timeLeft.value <= warning.threshold) {
        return warning.color
      } else {
        return info.color
      }
    })

    function onTimesUp() {
      clearInterval(timerInterval.value)
      emit('timesUp')
    }

    function startTimer() {
      timerInterval.value = setInterval(() => {
        if (props.start) {
          timePassed.value += 1
          emit('input', timeLeft.value)
        }
      }, 1000)
    }

    watch(timeLeft, (newValue) => { if (newValue === 0) onTimesUp() })

    onMounted(() => startTimer())

    return {
      radius,
      timePassed,
      timerInterval,
      circleDashArray,
      remainingPathColor,
      formattedTimeLeft,
      clockSize,
    }
  },
})
